import React from 'react';
import { Users, Database, Cpu, Coins } from 'lucide-react';
import { approach, commitment } from '../data/mock';

const ApproachSection = () => {
  const pillars = [
    {
      icon: Users,
      title: 'People',
      description: 'Expert teams with decades of real-world experience across emerging markets'
    },
    {
      icon: Database,
      title: 'Data',
      description: 'Intelligence-driven insights for strategic decision-making'
    },
    {
      icon: Cpu,
      title: 'Technology',
      description: 'Advanced solutions for modern challenges and operational excellence'
    },
    {
      icon: Coins,
      title: 'Capital',
      description: 'Strategic investment facilitation and financial advisory'
    }
  ];

  return (
    <section id="approach" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-sm tracking-[0.3em] text-gray-500 uppercase mb-3">How We Work</p>
          <h2 className="text-3xl md:text-4xl font-serif font-medium text-gray-900 mb-6">
            Our Approach
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-[#002060] to-gray-400 mx-auto mb-6" />
          <p className="max-w-3xl mx-auto text-gray-600 leading-relaxed">
            {approach.description}
          </p>
        </div>

        {/* Pillars */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          {pillars.map((pillar, index) => (
            <div
              key={index}
              className="group relative p-8 bg-slate-50 rounded-2xl hover:bg-[#002060] transition-all duration-500 hover:shadow-2xl hover:-translate-y-2"
            >
              <div className="w-16 h-16 bg-[#002060]/10 group-hover:bg-white/20 rounded-2xl flex items-center justify-center mb-6 transition-colors duration-500">
                <pillar.icon className="w-8 h-8 text-[#002060] group-hover:text-white transition-colors duration-500" />
              </div>
              <h3 className="text-xl font-serif font-semibold text-gray-900 group-hover:text-white mb-3 transition-colors duration-500">
                {pillar.title}
              </h3>
              <p className="text-gray-600 group-hover:text-gray-200 leading-relaxed transition-colors duration-500">
                {pillar.description}
              </p>
              {/* Decorative Number */}
              <span className="absolute top-4 right-4 text-6xl font-serif font-bold text-gray-200/50 group-hover:text-white/10 transition-colors duration-500">
                {String(index + 1).padStart(2, '0')}
              </span>
            </div>
          ))}
        </div>

        {/* Commitment Section */}
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-slate-900 via-slate-800 to-[#002060] p-12 lg:p-16">
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute inset-0" style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
            }} />
          </div>
          
          <div className="relative z-10 text-center">
            <h3 className="text-2xl md:text-3xl font-serif font-medium text-white mb-6">
              {commitment.title}
            </h3>
            <p className="max-w-3xl mx-auto text-gray-300 leading-relaxed mb-8">
              {commitment.description}
            </p>
            <p className="text-xl md:text-2xl font-serif italic text-white/90">
              "{commitment.tagline}"
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ApproachSection;
